import React, {useEffect, useState} from "react";
import {Box, Button, Grid, Modal, Typography, useMediaQuery} from "@mui/material";
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import Draggable from "react-draggable";
import {ReactComponent as CloseIcon} from "../../../assets/close_icon.svg";
import {ProgressBarWithLabel} from "../progressBar/progressBar";
import {PageSpinner} from "../../com/pagesTab/pagesSpinner/spinner";
import {NotUploadedImagesDto} from "../../../dtos";
import {ReactComponent as SuccessIcon} from "../../../assets/promos&items/approved_item_in_promo.svg";
import {ReactComponent as ErrorIcon} from "../../../assets/error_icon.svg";
import {ReactComponent as SuccessIconWithCircle} from "../../../assets/big_success_with_circle_icon.svg";
import {ReactComponent as FailedIconWithCircle} from "../../../assets/big_failed_with_circle_icon.svg";
import {ReactComponent as WarningIconWithCircle} from "../../../assets/big_warning_with_circle_icon.svg";
import {useDispatch} from "react-redux";
import {closeUploadingImagesProgressPopup} from "../../../store/actionCreators/uploadingImagesProgressActionCreator";
import {getFlippingFlyer} from "../../../store";
import {makeStyles} from "@mui/styles";
import {formatBytes} from "../../../globals/globalFunctions";
import {toggleFlyerDetailsPopup} from "../../../store/actionCreators/toggleActionForEditorActionCreators";

const useStyles = makeStyles(() => ({
    uploadingPopupWrapper: {
        position: `absolute`,
        // minHeight: `200px`,
        maxHeight: `500px`,
        backgroundColor: `#ffffff`,
        borderRadius: `5px`,
        border: `1px solid black`,
        display: `flex`,
        flexDirection: `column`,
        // rowGap: `20px`,
        zIndex: 5,
    },
    uploadingContentPopupWrapper: {
        padding: `10px 20px 20px`,
        rowGap: "20px",
        display: "flex",
        flexFlow: "column",
    },
    uploadingPopupHeaderWrapper: {
        height: "40px",
        position: "relative",
    },
    closeBtn: {
        '&.MuiButton-root': {
            padding: `4px`,
            position: `absolute`,
            top: `50%`,
            transform: "translateY(-50%)",
            right: `12px`,
            '& > svg > path': {
                fill: `#000000`
            },
            '&:hover': {
                backgroundColor: `#014780`,
                '& > svg > path': {
                    fill: `#ffffff`
                },
            }

        }
    },
    uploadingStatusInfo: {
        display: `flex`,
        columnGap: `5px`,
        alignItems: `center`
    },
    uploadingFinishedWrapper: {
        display: `flex`,
        flexDirection: `column`,
        alignItems: `center`,
        justifyContent: `center`,
        rowGap: `20px`,
    },
    showHideErrorsBtn: {
        display: "flex",
        justifyContent: "flex-end",
        '& > .MuiButton-root': {
            // width: `100%`,
            height: `100%`,
            display: `flex`,
        }
    },
    errorsRowsWrapper: {
        border: `1px solid rgba(0, 0, 0, 0.12)`,
        borderRadius: `2px`,
        padding: `16px`,
        rowGap: `8px`,
        display: `flex`,
        flexDirection: `column`,
        maxHeight: `240px`,
        overflow: `auto`
    },
    errorIconWrapper: {
        display: `flex`,
        alignItems: `center`,
        height: `100%`,
        justifyContent: `flex-start`,
        padding: `4px 0`
    },
    successfulMessageWrapper: {
        marginRight: `16px`,
        display: `flex`,
        alignItems: `baseline`,
        columnGap: `5px`,
        flexFlow: `row`,
    }
}));

interface Props {
    isModal?: boolean
}

export const UploadImagesProgressPopup: React.FC<Props> = ({
                                                               isModal
                                                           }) => {
    const dispatch = useDispatch();
    const {uploadImagesPopup, flyerDetails} = useTypedSelector((state) => state);
    const [isShowErrorsDetails, changeErrorDetailsDetails] = useState<boolean>(false);
    const [isCopied, setIsCopied] = useState<boolean>(false);
    let {isShowCreateNewFlyerPopup} = useTypedSelector((state) => state.toggleActionsForFlyers);
    const classes = useStyles();
    const isXs = useMediaQuery(`(max-width:599px)`);

    useEffect(() => {
        if (flyerDetails.flyRecId !== 0 && uploadImagesPopup.total !== 0 && uploadImagesPopup.processingFinished) {
            dispatch(getFlippingFlyer(flyerDetails.flyRecId));
        }
    }, [uploadImagesPopup.processingFinished, uploadImagesPopup.total]);

    const toggleErrorsDetails = () => {
        changeErrorDetailsDetails(!isShowErrorsDetails);
    }

    const copyAllErrors = () => {
        if(uploadImagesPopup.notUploadedImages){
            // Create a string containing all the messages separated by new lines
            const messageString = uploadImagesPopup.notUploadedImages.map(error => error.message).join("\n") || "";

            // Copy the message string to the clipboard
            navigator.clipboard.writeText(messageString).then(() => {
                console.log("Messages copied to clipboard.");
                setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
                }, 1000)
            });
        }
    }

    const onClosePopup = () => {
        dispatch(closeUploadingImagesProgressPopup());
        if (isShowCreateNewFlyerPopup) {
            dispatch(toggleFlyerDetailsPopup(false));
        }
    }

    const errors = uploadImagesPopup.notUploadedImages?.map((error: NotUploadedImagesDto, index) => {
        return (
            <Grid key={index} container columns={24} alignItems={`start`} justifyContent={`flex-start`}>
                <Grid item xs={1}>
                    <Box
                        className={classes.errorIconWrapper}
                    >
                        <ErrorIcon/>
                    </Box>
                </Grid>
                <Grid item xs>
                    {/*<Box>*/}
                    {/*    <Typography sx={{*/}
                    {/*        wordBreak: `break-all`,*/}
                    {/*        fontSize: `12px`,*/}
                    {/*        color: `#4D4D4D`*/}
                    {/*    }}>*/}
                    {/*        {error.imageFileName}*/}
                    {/*    </Typography>*/}
                    {/*</Box>*/}
                    <Box>
                        <Typography
                            sx={{
                                wordBreak: `break-all`,
                                fontSize: `12px`,
                                color: `#2A2A2A`,
                                lineHeight: 1.5
                            }}>
                            {error.message}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        )
    })
    const content = (
        <Box
            className={`${classes.uploadingPopupWrapper}`}
            sx={{
                top: isModal ? '50%' : '0',
                right: isModal ? '50%' : '0',
                transform: isModal ? 'translate(50%, -50%)' : 'none',
                width: isXs ? `90%` : `500px`
            }}

        >
            <Box
                id={`uploadImagesDragArea`}
                className={classes.uploadingPopupHeaderWrapper}
                sx={{
                    "&:hover": {
                        backgroundColor: !isModal ? "#e4e4e480" : "#ffffff",
                        cursor: !isModal ? "move" : "default"
                    }
                }}
            >
                {
                    uploadImagesPopup.processingFinished &&
                    <Button
                        className={classes.closeBtn}
                        onClick={onClosePopup}
                    >
                        <CloseIcon/>
                    </Button>
                }
            </Box>
            <Box
                className={classes.uploadingContentPopupWrapper}
            >
                {
                    (uploadImagesPopup.total === 0 && !uploadImagesPopup.processingFinished)
                        ?
                        <Box sx={{
                            display: `flex`,
                            justifyContent: `center`,
                            alignItems: `center`,
                            height: `118px`,
                            flexFlow: "column",
                            rowGap: "20px",
                        }}>
                            {/*{*/}
                            {/*    uploadImagesPopup.titlePopup === 'Image Upload Started' &&*/}
                            <Typography>
                                {uploadImagesPopup.titlePopup || "Uploading images..."}
                            </Typography>
                            {/*}*/}
                            <PageSpinner/>
                        </Box>
                        :
                        <>
                            {
                                uploadImagesPopup.processingFinished
                                    ?
                                    <Box
                                        className={`${classes.uploadingFinishedWrapper}`}
                                    >
                                        <Box>
                                            {uploadImagesPopup.successCount === uploadImagesPopup.total && uploadImagesPopup.total !== 0 &&
                                                <SuccessIconWithCircle/>
                                            }
                                            {(uploadImagesPopup.failCount === uploadImagesPopup.total || uploadImagesPopup.total === 0) &&
                                                <FailedIconWithCircle/>
                                            }
                                            {uploadImagesPopup.failCount !== uploadImagesPopup.total && uploadImagesPopup.successCount !== uploadImagesPopup.total && uploadImagesPopup.total !== 0 &&
                                                <WarningIconWithCircle/>
                                            }
                                        </Box>
                                        <Box>
                                            <Typography
                                                fontSize={`14px`}
                                                fontWeight={`700`}
                                            >
                                                {uploadImagesPopup.titlePopup}
                                                {/*{uploadImagesPopup.successCount} Files Uploaded Successfully*/}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    :
                                    <Box>
                                        <Box
                                            className={classes.successfulMessageWrapper}
                                        >
                                            {
                                                !uploadImagesPopup.isUploadingFilesToSystem &&
                                                <>
                                                    {
                                                        uploadImagesPopup.severityLevel === "Error"
                                                            ?
                                                            <ErrorIcon style={{minWidth: `14px`}}/>
                                                            :
                                                            <SuccessIcon style={{minWidth: `14px`}}/>
                                                    }
                                                </>

                                            }
                                            <Typography
                                                sx={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: `inherit`,
                                                    // maxWidth: `100%`,
                                                    display: "-webkit-box",
                                                    "WebkitLineClamp": 2,
                                                    "WebkitBoxOrient": "vertical"
                                                }}
                                                fontSize={`14px`} lineHeight={`20px`} height={`40px`}>
                                                {uploadImagesPopup.titlePopup}
                                            </Typography>
                                        </Box>
                                        <ProgressBarWithLabel withLabel={true}
                                                              value={Number(Math.floor((uploadImagesPopup.current * 100) / uploadImagesPopup.total))}/>
                                    </Box>
                            }
                            <Box>
                                <Grid container>
                                    <Grid item xs={8}>
                                        <Box sx={{
                                            display: `flex`,
                                            columnGap: `10px`,
                                            height: `100%`
                                        }}>
                                            <Box
                                                className={classes.uploadingStatusInfo}
                                            >
                                                <SuccessIcon/>
                                                <Typography
                                                    fontSize={`12px`}
                                                >
                                                    {uploadImagesPopup.isUploadingFilesToSystem ? `${formatBytes(uploadImagesPopup.current)}/${formatBytes(uploadImagesPopup.total)}` : `${uploadImagesPopup.successCount}/${uploadImagesPopup.total} successful`}
                                                </Typography>
                                            </Box>
                                            {
                                                uploadImagesPopup.failCount !== 0 &&
                                                <Box
                                                    className={classes.uploadingStatusInfo}
                                                >
                                                    <ErrorIcon/>
                                                    <Typography
                                                        fontSize={`12px`}
                                                    >
                                                        {uploadImagesPopup.failCount}/{uploadImagesPopup.total} errors
                                                    </Typography>
                                                </Box>
                                            }
                                        </Box>
                                    </Grid>
                                    {uploadImagesPopup.failCount !== 0 &&
                                        <>
                                            <Grid item xs>
                                                <Box
                                                    className={classes.showHideErrorsBtn}
                                                >
                                                    <Button onClick={toggleErrorsDetails}>
                                                        <Typography lineHeight={1} fontSize={`12px`} p={`4px`}>
                                                            {isShowErrorsDetails ? `Hide Errors` : `Show Errors`}
                                                        </Typography>
                                                    </Button>
                                                </Box>
                                            </Grid>
                                            <Grid item xs>
                                                <Box
                                                    className={classes.showHideErrorsBtn}
                                                >
                                                    <Button onClick={copyAllErrors}
                                                        disabled={isCopied}
                                                    >
                                                        <Typography lineHeight={1} fontSize={`12px`} p={`4px`}>
                                                            {isCopied ? "Copied" : "Copy"}
                                                        </Typography>
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Box>
                            {
                                isShowErrorsDetails && uploadImagesPopup.failCount !== 0 &&
                                <Box
                                    className={classes.errorsRowsWrapper}
                                >
                                    {errors}
                                </Box>
                            }
                        </>
                }
            </Box>
        </Box>
    )

    if (uploadImagesPopup.isOpen) {
        if (isModal) {
            return (
                <Modal open={uploadImagesPopup.isOpen}>
                    {content}
                </Modal>
            )
        } else {
            return (
                <Draggable
                    bounds="parent"
                    handle={`#uploadImagesDragArea`}
                    defaultPosition={{x: 0, y: 0}}
                >
                    {content}
                </Draggable>
            )

        }

    } else {
        return (
            <></>
        )
    }
}